var _a, _b;
export var MUTATIONS = {
    SET_GLOBAL_SEARCH_TERM: 'mutations/globalSearch/setGlobalSearchTerm',
    SET_GLOBAL_SEARCH_TITLE: 'mutations/globalSearch/setGlobalSearchTitle',
    SET_PREVIOUS_VISITED_PAGE: 'mutations/globalSearch/setPreviousVisitedPage',
    SET_GLOBAL_SEARCH_LOGO: 'mutations/globalSearch/setGlobalSearchLogo',
    SET_GLOBAL_SEARCH_HEADER: 'mutations/globalSearch/setGlobalSearchHeader',
    SET_GLOBAL_SEARCH_SUBTITLE: 'mutations/globalSearch/setGlobalSearchSubTitle',
    SET_GLOBAL_SEARCH_SECTION: 'mutations/globalSearch/setGlobalSearchSection',
    SET_GLOBAL_SEARCH_UUID: 'mutations/globalSearch/setGlobalSearchUuid',
};
export var ACTIONS = {
    SET_GLOBAL_SEARCH_TERM: 'actions/globalSearch/setGlobalSearchTerm',
    SET_GLOBAL_SEARCH_TITLE: 'actions/globalSearch/setGlobalSearchTitle',
    SET_PREVIOUS_VISITED_PAGE: 'actions/globalSearch/setPreviousVisitedPage',
    SET_GLOBAL_SEARCH_LOGO: 'actions/globalSearch/setGlobalSearchLogo',
    SET_GLOBAL_SEARCH_HEADER: 'actions/globalSearch/setGlobalSearchHeader',
    SET_GLOBAL_SEARCH_SUBTITLE: 'actions/globalSearch/setGlobalSearchSubTitle',
    SET_GLOBAL_SEARCH_SECTION: 'actions/globalSearch/setGlobalSearchSection',
    SET_GLOBAL_SEARCH_UUID: 'actions/globalSearch/setGlobalSearchUuid',
};
export var globalSearchModule = {
    state: {
        globalSearchTerm: '',
        globalSearchTitle: '',
        previousVisitedPage: '',
        globalSearchLogo: '',
        globalSearchHeader: '',
        globalSearchSubTitle: '',
        globalSearchSection: '',
        globalSearchUuid: '',
    },
    getters: {
        globalSearchTerm: function (state) {
            return state.globalSearchTerm;
        },
        globalSearchTitle: function (state) {
            return state.globalSearchTitle;
        },
        previousVisitedPage: function (state) {
            return state.previousVisitedPage;
        },
        globalSearchLogo: function (state) {
            return state.globalSearchLogo;
        },
        globalSearchHeader: function (state) {
            return state.globalSearchHeader;
        },
        globalSearchSubTitle: function (state) {
            return state.globalSearchSubTitle;
        },
        globalSearchSection: function (state) {
            return state.globalSearchSection;
        },
        globalSearchUuid: function (state) {
            return state.globalSearchUuid;
        }
    },
    mutations: (_a = {},
        _a[MUTATIONS.SET_GLOBAL_SEARCH_TERM] = function (state, searchTerm) {
            state.globalSearchTerm = searchTerm;
        },
        _a[MUTATIONS.SET_GLOBAL_SEARCH_TITLE] = function (state, searchTitle) {
            state.globalSearchTitle = searchTitle;
        },
        _a[MUTATIONS.SET_PREVIOUS_VISITED_PAGE] = function (state, previousVisitedPage) {
            state.previousVisitedPage = previousVisitedPage;
        },
        _a[MUTATIONS.SET_GLOBAL_SEARCH_LOGO] = function (state, logo) {
            state.globalSearchLogo = logo;
        },
        _a[MUTATIONS.SET_GLOBAL_SEARCH_HEADER] = function (state, header) {
            state.globalSearchHeader = header;
        },
        _a[MUTATIONS.SET_GLOBAL_SEARCH_SUBTITLE] = function (state, subTitle) {
            state.globalSearchSubTitle = subTitle;
        },
        _a[MUTATIONS.SET_GLOBAL_SEARCH_SECTION] = function (state, section) {
            state.globalSearchSection = section;
        },
        _a[MUTATIONS.SET_GLOBAL_SEARCH_UUID] = function (state, uuid) {
            state.globalSearchUuid = uuid;
        },
        _a),
    actions: (_b = {},
        _b[ACTIONS.SET_GLOBAL_SEARCH_TERM] = function (_a, searchTerm) {
            var commit = _a.commit;
            commit(MUTATIONS.SET_GLOBAL_SEARCH_TERM, searchTerm);
        },
        _b[ACTIONS.SET_GLOBAL_SEARCH_TITLE] = function (_a, searchTitle) {
            var commit = _a.commit;
            commit(MUTATIONS.SET_GLOBAL_SEARCH_TITLE, searchTitle);
        },
        _b[ACTIONS.SET_PREVIOUS_VISITED_PAGE] = function (_a, previousVisitedPage) {
            var commit = _a.commit;
            commit(MUTATIONS.SET_PREVIOUS_VISITED_PAGE, previousVisitedPage);
        },
        _b[ACTIONS.SET_GLOBAL_SEARCH_LOGO] = function (_a, logo) {
            var commit = _a.commit;
            commit(MUTATIONS.SET_GLOBAL_SEARCH_LOGO, logo);
        },
        _b[ACTIONS.SET_GLOBAL_SEARCH_HEADER] = function (_a, header) {
            var commit = _a.commit;
            commit(MUTATIONS.SET_GLOBAL_SEARCH_HEADER, header);
        },
        _b[ACTIONS.SET_GLOBAL_SEARCH_SUBTITLE] = function (_a, subTitle) {
            var commit = _a.commit;
            commit(MUTATIONS.SET_GLOBAL_SEARCH_SUBTITLE, subTitle);
        },
        _b[ACTIONS.SET_GLOBAL_SEARCH_SECTION] = function (_a, section) {
            var commit = _a.commit;
            commit(MUTATIONS.SET_GLOBAL_SEARCH_SECTION, section);
        },
        _b[ACTIONS.SET_GLOBAL_SEARCH_UUID] = function (_a, uuid) {
            var commit = _a.commit;
            commit(MUTATIONS.SET_GLOBAL_SEARCH_UUID, uuid);
        },
        _b)
};
